import axios from 'axios';
import authHeader from '../../auth-header';

import tokenHeader from '../../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../../base-url';

const API_URL = baseUrl()+"/api/all/";

const getSertifikasiRpl = 'data-peserta/sertifikasi-rpl-peserta';
const getDokumenPendukung = 'jadwal-test-center/dokumen-pendukung-peserta-sertifikasi';

class DataSertifikasiRplService {
    getSertifikasiRpl(currentPage,pageSize,filter,id_user) {
        return axios.get(
            API_URL + getSertifikasiRpl + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&id_user=' + id_user,
            {
                headers: authHeader()
            });
    }

    getDokumenPendukung() {
        return axios.get(
            API_URL + getDokumenPendukung,
            {
                headers: authHeader()
            });
    }

}

export default new DataSertifikasiRplService();